const values = [
  "card_hero_alchemist_musketter",
  "card_hero_angelwings",
  "card_hero_angelwings_awaken",
  "card_hero_angelwings_infernal",
  "card_hero_angelwings_teotl",
  "card_hero_avalanchesurfer_star",
  "card_hero_avalanche_surfer",
  "card_hero_avalanche_surfer_cloudrider",
  "card_hero_avalanche_surfer_poolparty",
  "card_hero_bearchief",
  "card_hero_bearchief_awaken",
  "card_hero_bearchief_naval",
  "card_hero_beemistress",
  "card_hero_beemistress_awaken",
  "card_hero_beemistress_thief",
  "card_hero_beetlewarrior",
  "card_hero_beetlewarrior_awaken",
  "card_hero_beetlewarrior_pool",
  "card_hero_centaurarcher",
  "card_hero_centaurarcher_awaken",
  "card_hero_centaurarcher_dryad",
  "card_hero_chosengirl_grandmaster",
  "card_hero_chosengirl_priestess",
  "card_hero_chosen_girl",
  "card_hero_cloudrabbit",
  "card_hero_cloudrabbit_awaken",
  "card_hero_cloudrabbit_tiger",
  "card_hero_cloudviking",
  "card_hero_cloudviking_awaken",
  "card_hero_cloudviking_dieselpunk",
  "card_hero_crazy_alchemsit",
  "card_hero_death_knight",
  "card_hero_death_knight_awaken",
  "card_hero_death_knight_star",
  "card_hero_dragoon_gm6",
  "card_hero_dragoon_star",
  "card_hero_dryad",
  "card_hero_dryad_awaken",
  "card_hero_dryad_chef",
  "card_hero_dryad_tropical",
  "card_hero_evilwings_poolparty",
  "card_hero_evil_wings",
  "card_hero_evil_wings_swampwitch",
  "card_hero_flamegoddess",
  "card_hero_flamegoddess_awaken",
  "card_hero_flamegoddess_catgirl",
  "card_hero_flamethrower_awaken",
  "card_hero_flamethrower_firewoman",
  "card_hero_flame_thrower",
  "card_hero_flame_thrower_landscaper",
  "card_hero_foreseer",
  "card_hero_foreseer_awaken",
  "card_hero_foreseer_citizen",
  "card_hero_hercules",
  "card_hero_hercules_awaken",
  "card_hero_hercules_mafia",
  "card_hero_icemage_dapper",
  "card_hero_last_dragoon",
  "card_hero_last_dragoon_musketeer",
  "card_hero_lavachef_awaken",
  "card_hero_lavachef_skinwitch",
  "card_hero_lava_chef",
  "card_hero_lava_chef_eaglewarrior",
  "card_hero_lionking",
  "card_hero_lionking_awaken",
  "card_hero_lionking_bbqchef",
  "card_hero_lionking_boxer",
  "card_hero_merfolk_dapper",
  "card_hero_merfolk_fighter",
  "card_hero_merfolk_fighter_maskedheroine",
  "card_hero_merfolk_poolparty",
  "card_hero_ramhammer",
  "card_hero_ramhammer_grandvizier",
  "card_hero_ramhammer_piratelord",
  "card_hero_reaper",
  "card_hero_reaper_awaken",
  "card_hero_reaper_infernal",
  "card_hero_reaper_spades",
  "card_hero_ronin",
  "card_hero_ronin_awaken",
  "card_hero_ronin_miku",
  "card_hero_ronin_surgingriver",
  "card_hero_sandscorpion",
  "card_hero_sandscorpion_awaken",
  "card_hero_sandscorpion_tribal",
  "card_hero_smith_gm6",
  "card_hero_smith_grandmaster",
  "card_hero_toadshaman_awaken",
  "card_hero_toadshaman_pirate",
  "card_hero_toad_shaman",
  "card_hero_tower_smith",
  "card_hero_tower_smith_infernal",
  "card_hero_traveling_mage",
  "card_hero_windknight_gm6",
  "card_hero_windknight_musketeer",
  "card_hero_windknight_star",
  "card_hero_wind_knight",
  "card_hero_wind_knight_grandmaster",
  "card_hero_wind_knight_maskedherione",
  "card_hero_wolfhuntress",
  "card_hero_wolfhuntress_awaken",
  "card_hero_wolfhuntress_woodlands",
  "card_hero_yeti",
  "card_hero_yeti_dapper",
  "card_hero_yeti_shortstop",
  "card_herp_wolfhuntress_maskedheroine",
  "card_banner",
  "card_blue",
  "card_brown",
  "card_gold",
  "card_green",
  "card_purple",
  "card_red",
  "card_spell_angelic_host",
  "card_spell_bolster",
  "card_spell_breathoffire",
  "card_spell_bubbleblast",
  "card_spell_castthebones",
  "card_spell_consecrate",
  "card_spell_darksummons",
  "card_spell_desecrate",
  "card_spell_divinecommand",
  "card_spell_dynastinae",
  "card_spell_fireball",
  "card_spell_fire_trap",
  "card_spell_focus_fire",
  "card_spell_frost_trap",
  "card_spell_fungalbloom",
  "card_spell_giftofkinahau",
  "card_spell_greed_cannon",
  "card_spell_holy_nova",
  "card_spell_howling_blast",
  "card_spell_ice_rupture",
  "card_spell_judgement",
  "card_spell_lightning_bolt",
  "card_spell_magmafall",
  "card_spell_manastorm",
  "card_spell_mightofyaoga",
  "card_spell_polybomb",
  "card_spell_salvo",
  "card_spell_skywindsaga",
  "card_spell_spikedbarricade",
  "card_spell_thunder_wave",
  "card_spell_treants",
  "card_spell_typhoon",
  "card_spell_vine_lash",
  "card_spell_warbots",
  "card_tower_arcane_tower",
  "card_tower_arrow",
  "card_tower_axemantower",
  "card_tower_barrack",
  "card_tower_beetletower",
  "card_tower_bigheadtower",
  "card_tower_cannon",
  "card_tower_catapulttower",
  "card_tower_centaurbarracks",
  "card_tower_cloudtower",
  "card_tower_crusader",
  "card_tower_darkportal",
  "card_tower_dragoonbarracks",
  "card_tower_druid",
  "card_tower_flame_cannon",
  "card_tower_frost_tower",
  "card_tower_hunters_hut",
  "card_tower_iceman",
  "card_tower_lavaooze",
  "card_tower_leviathan",
  "card_tower_light_house",
  "card_tower_merman",
  "card_tower_mummybarracks",
  "card_tower_oiltower",
  "card_tower_planttower",
  "card_tower_potiondealer_tower",
  "card_tower_repeater",
  "card_tower_scorcher",
  "card_tower_stoneguard",
  "card_tower_sunsanctum",
  "card_tower_tesla",
  "card_tower_warlocktower",
  "card_unknown",
  "icon_ingame_cooldown",
  "icon_ingame_towerslot_arrowtower",
  "icon_ingame_towerslot_axemantower",
  "icon_ingame_towerslot_barracks",
  "icon_ingame_towerslot_beetletower",
  "icon_ingame_towerslot_bigheadtower",
  "icon_ingame_towerslot_cannontower",
  "icon_ingame_towerslot_catapulttower",
  "icon_ingame_towerslot_centaurbarracks",
  "icon_ingame_towerslot_cloudtower",
  "icon_ingame_towerslot_crusader",
  "icon_ingame_towerslot_darkportal",
  "icon_ingame_towerslot_darkspire",
  "icon_ingame_towerslot_dragoonbarracks",
  "icon_ingame_towerslot_druidtower",
  "icon_ingame_towerslot_flamecannon",
  "icon_ingame_towerslot_frosttower",
  "icon_ingame_towerslot_huntershut",
  "icon_ingame_towerslot_icemantower",
  "icon_ingame_towerslot_lavaooze",
  "icon_ingame_towerslot_leviathan",
  "icon_ingame_towerslot_lighthouse",
  "icon_ingame_towerslot_merman",
  "icon_ingame_towerslot_mummybarracks",
  "icon_ingame_towerslot_oiltower",
  "icon_ingame_towerslot_planttower",
  "icon_ingame_towerslot_potiondealer",
  "icon_ingame_towerslot_repeater",
  "icon_ingame_towerslot_scorcher",
  "icon_ingame_towerslot_stoneguard",
  "icon_ingame_towerslot_sunsanctum",
  "icon_ingame_towerslot_teslatower",
  "icon_ingame_towerslot_warlocktower",
];
export default values;
